// extracted by mini-css-extract-plugin
export var text = "_9s-0";